import script from "./SortButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortButton.vue?vue&type=script&setup=true&lang=ts"

import "./SortButton.vue?vue&type=style&index=0&id=4333887c&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4333887c"]])

export default __exports__